import React, { useEffect } from "react";
import { useCategoryList, useProductList } from "../use-fetch-cosmicjs-state";
import { useSearch } from "../use-search";
import { useFocus } from "../../../organisms/help/category/use-focus";
import { useTitle } from "../../../../utils/use-title";

export const useHelpHomeController = () => {
  const categoryListResult = useCategoryList();

  const productListResult = useProductList();

  const ref = React.useRef<HTMLDivElement>(null);
  const focus = useFocus(ref);

  useEffect(() => {
    if (!ref.current) return;
    focus();
  }, [focus, ref]);

  return {
    categoryListResult,
    productListResult,
    ref,
  };
};

export const useHelpTopController = () => {
  const {
    result,
    query,
    onChangeQuery,
    condition,
    onChangeCondition,
    productId,
    onChangeProduct,
    tags,
    onChangeTags,
    isLoading,
  } = useSearch();

  const title = "ヘルプサイト";

  useTitle(title);

  return {
    title,
    result,
    isLoading,
    query,
    condition,
    onChangeSearchText: onChangeQuery,
    onChangeSearchCondition: onChangeCondition,
    productId,
    tags,
    onChangeProduct,
    onChangeTags,
  };
};
